import { render } from "./LegacyCustomFields.vue?vue&type=template&id=cc6761be"
import script from "./LegacyCustomFields.vue?vue&type=script&lang=js"
export * from "./LegacyCustomFields.vue?vue&type=script&lang=js"
script.render = render

export default script